import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function ExclusiveSpotlight() {
  const spotlight =
    articles.find((item) => item.category === "investigation") ?? articles[0];
  const related = articles
    .filter((item) => item.category === "investigation" || item.category === "depth")
    .filter((item) => item.id !== spotlight.id)
    .slice(0, 4);

  return (
    <section aria-labelledby="exclusive-title" className="mx-auto w-full max-w-shell px-4 py-12 md:px-6 md:py-14">
      <div className="mb-7 border-b border-background-200 pb-4">
        <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-primary-600">
          <span className="h-px w-6 bg-primary-500" />
          独家调查
        </p>
        <h2 id="exclusive-title" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          我们用几周时间，只为回答一个「为什么」
        </h2>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          三条独立信源、一张时间线、一次次交叉比对。调查报道不追热点，它追的是逻辑能否自洽。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="rise-in lg:col-span-7">
          <Link
            to={`/article/${spotlight.id}`}
            className="group block h-full cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="relative h-64 w-full overflow-hidden md:h-80">
              <img
                src={spotlight.cover}
                alt={spotlight.title}
                title={`${spotlight.title} - 爆料在线`}
                className="h-full w-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
                本刊调查组
              </span>
            </div>
            <div className="p-6">
              <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-2xl">
                {spotlight.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{spotlight.excerpt}</p>
              <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-secondary-600">
                <span className="flex items-center gap-1">
                  <i className="ri-user-3-line" aria-hidden="true" />
                  {spotlight.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true" />
                  {spotlight.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true" />
                  {spotlight.views} 阅读
                </span>
                <span className="ml-auto flex items-center gap-1 font-medium text-primary-600">
                  进入调查
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </span>
              </div>
            </div>
          </Link>
        </div>

        <div className="lg:col-span-5">
          <div className="flex flex-col gap-5">
            {related.map((item) => (
              <ArticleCard key={item.id} article={item} variant="wide" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}